import { Component } from 'react';
import propTypes from 'prop-types';
import { observer } from 'mobx-react';
import { QtyEditable } from './QtyEditable';
import { QtyStatic } from './QtyStatic';

class _QtyControl extends Component {
  render() {
    return (
      this.props.isEditable
        ? <QtyEditable item={this.props.item} />
        : <QtyStatic item={this.props.item} label={this.props.label} />
    );
  }
}

_QtyControl.propTypes = {
  item: propTypes.shape({
    quantity: propTypes.oneOfType([propTypes.number, propTypes.string]),
    changeQty: propTypes.func,
    setQty: propTypes.func
  }).isRequired,
  isEditable: propTypes.bool,
  label: propTypes.string
};

export const QtyControl = observer(_QtyControl);
